<template>
  <div>
    <!-- AppHeaderNew -->
    <AppHeaderNew />

    <section class="pages-banner">
      <div class="container text-center banner-box h-100">
        <h1>Contact Us</h1>
      </div>
    </section>

    <div class="container inner-page-box faq-page-box">
      <div class="container breadcrumb-box">
        <p>
          <router-link :to="{name: 'home'}">Home</router-link>> Contact Us
        </p>
      </div>
      <h3>Contact Us</h3>
      <div class="contact-us-page-box">

        <div class="company-address">
          <h1>
            <span class="amej">Amej</span>
            <span class="pay">Pay Pte. Ltd.</span>
          </h1>
          <h5><strong>Corporate Office &mdash; Asia Pacific (APAC)</strong></h5>
          <p>S&amp;J Building, 104, Rachaparop Soi 1, Phayathai, Bangkok 10400 Thailand</p>
          <p>
            Phone:
            <span>+66 626513995</span>
          </p>
          <p>
            Email:
            <span>apac@amejpay.com</span>
          </p>
        </div>

        <div class="row contact-page-support">

          <div class="col-md-12">
            <h4><strong>Branches & Network</strong></h4>
            <br clear="all"/>
          </div>

          <div class="col-md-6">
            <div style="width: 100%; height: 25px; float: left;">&nbsp;</div>
            <h5>USA Office</h5>
            <p>Amejpay USA Branch</p>
            <p>24 Lark lane, Croton On Hudson, New York 10520</p>
            <p>Phone: <span>+1 9148062214</span></p>
            <p>Email: <span>usa@amejpay.com</span></p>
          </div>

          <div class="col-md-6">
            <div style="width: 100%; height: 25px; float: left;">&nbsp;</div>
            <h5>Thailand Office</h5>
            <p>&nbsp;</p>
            <p>S&amp;J Building, 104, Rachaparop Soi 1, Phayathai, Bangkok 10400 Thailand</p>
            <p>Phone: <span>+66 626513995</span></p>
            <p>Email: <span>thailand@amejpay.com</span></p>
          </div>
          

        </div>

        <div class="row contact-page-support">

          <div class="col-md-6">
            <h5>Customer Support</h5>
            <p>
              <span>support@amejpay.com</span>
            </p>
          </div>

        </div>

      </div>
    </div>

    <!-- FooterNew -->
    <AppFooterNew />
  </div>
</template>

<script type="text/javascript">
import AppHeaderNew from "../reuseable_components/HeaderNew";
import AppFooterNew from "../reuseable_components/FooterNew";

export default {
  name: "contactPageNew",
  components: {
    AppHeaderNew,
    AppFooterNew,
  },
  data() {
    return {
      //
    };
  },
};
</script>